export * from 'utils/bolt/dynamicData.js';
// import * as base from 'utils/bolt/dynamicData.js';
// import Store from 'store/store';
import { isImage, isNativeVideo, isPDF, isYoutube, getYoutubeId } from 'utils/cms/mediaFiles';

export function transformPageData(data) {
	const bg = {
		desktop: {
			asset: `${__MEDIA_ROOT__}/video/hero.mp4`,
			preLoadImg: `${__IMAGE_ROOT__}/video-preload/hero.webp`,
			disableLoop: true,
			fallbackImg: `${__IMAGE_ROOT__}/video-preload/hero.webp`
		}
	};

	const contentCarousel = (data.gallery || []).reduce((acc, item, index) => {
		acc = {
			...acc,
			[item.id]: {
				order: index + 1,
				ariaLabel: item.alt,
				alt: item.alt,
				// annotation: item.annotation,
				title: item.title,
				description: item.description,
				pdfSrc: isPDF(item.file) ? item.file : undefined,
				videoSrc: isNativeVideo(item.file) ? item.file : undefined,
				desktopSrc: isImage(item.file) ? item.file : undefined,
				youtubeId: isYoutube(item.file) ? getYoutubeId(item.file) : undefined,
				fileToDownload: item.fileToDownload,
				path: item.link
			}
		};
		return acc;
	}, {});

	return [{
		base: 'bolt',
		id: data.url,
		data: {
			backButton: '<a href="#$events">All Events</a>',
			title: data.title,
			description: data.intro,
			// expandableItems: data.expandableTextSection?.items || [],
			// buttonSections: data.buttonSections || [],
			galleryDescription: data.galleryDescription || '',
			// bg,
			contentCarousel,
			downloadAll: false,
			downloadSingle: false,
			hideArrowsDesktop: false,
			hideArrowsMobile: true
		},
		type: 'eventAlbum',
		customPageComponent: 'eventAlbum',
		page: 'eventAlbum',
		path: '/' + data.url + '/'
	}];
}